/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetCalculationCycleDetailNoteRequest
 */
export interface SetCalculationCycleDetailNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof SetCalculationCycleDetailNoteRequest
     */
    note: string | null;
}

/**
 * Check if a given object implements the SetCalculationCycleDetailNoteRequest interface.
 */
export function instanceOfSetCalculationCycleDetailNoteRequest(value: object): value is SetCalculationCycleDetailNoteRequest {
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function SetCalculationCycleDetailNoteRequestFromJSON(json: any): SetCalculationCycleDetailNoteRequest {
    return SetCalculationCycleDetailNoteRequestFromJSONTyped(json, false);
}

export function SetCalculationCycleDetailNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetCalculationCycleDetailNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function SetCalculationCycleDetailNoteRequestToJSON(json: any): SetCalculationCycleDetailNoteRequest {
    return SetCalculationCycleDetailNoteRequestToJSONTyped(json, false);
}

export function SetCalculationCycleDetailNoteRequestToJSONTyped(value?: SetCalculationCycleDetailNoteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
    };
}

